export default __webpack_public_path__ + "static/media/Frenetic Gloves.e2cda269.jpg";